// @flow
import { type Event, getEventCategoryAccount } from './config';

const updateAccountDetails = (): Event => ({
  category: getEventCategoryAccount(),
  action: 'AccountDetails',
  label: 'Update',
});

const notification = (label: string = ''): Event => ({
  category: getEventCategoryAccount(),
  action: 'Notifications',
  label,
});

export default {
  updateAccountDetails,
  notification,
};
